import { areValuesEqualOrBothUndefined } from '../../../../utils/equivalence-utils';
export const areOrderTicketRequestsEqual = (ticketA, ticketB) => {
    return (ticketA.ticketTypeId === ticketB.ticketTypeId &&
        areValuesEqualOrBothUndefined(ticketA.rewardId, ticketB.rewardId) &&
        areValuesEqualOrBothUndefined(ticketA.ticketRedemptionCardId, ticketB.ticketRedemptionCardId) &&
        areValuesEqualOrBothUndefined(ticketA.voucherId, ticketB.voucherId));
};
